import {Stack, Typography} from "@mui/material";
import theme from "@nitra/nkmb-theme";
import React from "react";
import {BlackPageContainer} from "../../components/BlackPageContainer";
import {VoteOption} from "../../models";
import {VotingPage} from "./VotingPage";

export function CupVotingComponent() {
	const cups: VoteOption[] = [{
		key: "handa",
		imageUrl: "/images/cupVoting/MASTERCARD_glasovanje_Handa_331x331.jpg",
		label: "Handanović"
	}, {
		key: "rajcevic",
		imageUrl: "/images/cupVoting/MASTERCARD_glasovanje_Rajcevic_331x331.jpg",
		label: "Rajčević"
	}, {
		key: "viler",
		imageUrl: "/images/cupVoting/MASTERCARD_glasovanje_Viler_331x331.jpg",
		label: "Viler"
	}, {
		key: "balajic",
		imageUrl: "/images/cupVoting/MASTERCARD_glasovanje_Balajic_331x331.jpg",
		label: "Balajić"
	}, {
		key: "tava",
		imageUrl: "/images/cupVoting/MASTERCARD_glasovanje_Tava_331x331.jpg",
		label: "Tavares"
	}]


	return (
		<BlackPageContainer blackOverride={"black"}>
			<VotingPage
				voteOptions={cups}
				desktopBannerUrl={"/images/cupVoting/MASTERCARD_web_banner_spletna_1440x480.jpg"}
				mobileBannerUrl={"/images/cupVoting/MASTERCARD_web_banner_spletna_1440x1080.jpg"}
				votingKey={"kozarec-legende-2025"}
			>
				<Stack spacing={5} sx={{pt: 5, alignItems: "center"}}>
					{/*<Typography variant={"podnaslovL"}*/}
					{/*            sx={{color: theme.palette.background.default, textAlign: "center"}}>*/}
					{/*	Pomagaj odločiti tekmo za najbolj legendarni kozarec!*/}
					{/*</Typography>*/}
					<Typography variant={"bodyXL"}
					            sx={{color: theme.palette.background.default, textAlign: "center"}}>
						Oddaj svoj glas in se poteguj za vrhunsko vijol’čno izkušnjo ali enega izmed najbolj zaželenih
						navijaških artiklov.
					</Typography>
					<Typography variant={"bodyXL"} sx={{color: theme.palette.background.default, textAlign: "center"}}>
						Izmed vseh prispelih glasov bomo 23. 5. izžrebali prejemnike legendarnih nagrad.
					</Typography>
				</Stack>
			</VotingPage>
		</BlackPageContainer>
	)
}
